import React from 'react';

function CoursesLoading() {
  return (
    <div className="courses-container">
      <div className="courses-layout">
        {/* Sidebar Skeleton */}
        <div className="sidebar-skeleton">
          <div className="skeleton-menu-item" style={{ width: '80%', height: '30px' }}></div>
          <div className="skeleton-menu-item" style={{ width: '70%', height: '30px' }}></div>
          <div className="skeleton-menu-item" style={{ width: '90%', height: '30px' }}></div>
        </div>

        <main className="course-content">
          {/* Header Skeleton */}
          <div className="course-header">
            <div className="skeleton-text" style={{ width: '120px', height: '32px' }}></div>
            <div className="skeleton-icon" style={{ width: '24px', height: '24px' }}></div>
          </div>

          {/* Search Box Skeleton */}
          <div className="search-box-skeleton">
            <div className="skeleton-input" style={{ height: '40px' }}></div>
          </div>

          {/* Categories Skeleton */}
          <div className="categories-skeleton">
            {[...Array(5)].map((_, i) => (
              <div key={i} className="skeleton-category" style={{ width: `${80 + i * 20}px`, height: '32px' }}></div>
            ))}
          </div>

          {/* Classes List Skeleton */}
          <div className="classes-skeleton">
            {[...Array(4)].map((_, i) => (
              <div key={i} className="skeleton-class-card">
                <div className="skeleton-class-image"></div>
                <div className="skeleton-class-content">
                  <div className="skeleton-class-title"></div>
                  <div className="skeleton-class-meta"></div>
                  <div className="skeleton-class-price"></div>
                </div>
              </div>
            ))}
          </div>
        </main>
      </div>
    </div>
  );
}

export default CoursesLoading;